module.exports = __webpack_public_path__ + "static/assets/75a7b6c723f56253843bb04df776c846.svg";